import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { getAnalyticsPagePayload, trackEvent, updateAnalyticsConsent } from '../lib/analytics';

const CONSENT_STORAGE_KEY = 'greenbook:analytics-consent';

const AnalyticsConsentBanner = () => {
  const [consent, setConsent] = useState(() => {
    if (typeof window === 'undefined') return 'unknown';
    return window.localStorage.getItem(CONSENT_STORAGE_KEY) || 'unknown';
  });

  useEffect(() => {
    if (consent === 'granted') updateAnalyticsConsent(true);
    if (consent === 'denied') updateAnalyticsConsent(false);
  }, [consent]);

  const setPreference = (nextConsent) => {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, nextConsent);
    if (nextConsent === 'granted') {
      updateAnalyticsConsent(true);
      trackEvent('page_view', getAnalyticsPagePayload());
    }
    setConsent(nextConsent);
  };

  if (consent !== 'unknown') return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 border-t border-gray-200 bg-white/95 px-4 py-4 shadow-lg backdrop-blur dark:border-gray-800 dark:bg-gray-950/95">
      <div className="mx-auto flex max-w-5xl flex-col gap-3 text-sm text-gray-800 dark:text-gray-100 sm:flex-row sm:items-center sm:justify-between">
        <p className="max-w-3xl">
          Usamos analytics para entender busca, cadastro e contribuições sem coletar dados pessoais nos eventos.
        </p>
        <div className="flex shrink-0 gap-2">
          <button
            type="button"
            className={clsx(
              'rounded-lg border px-4 py-2 font-semibold transition-colors',
              'border-gray-300 text-gray-700 hover:border-greenbook-light-primary dark:border-gray-700 dark:text-gray-100'
            )}
            onClick={() => setPreference('denied')}
          >
            Recusar
          </button>
          <button
            type="button"
            className="rounded-lg bg-greenbook-light-primary px-4 py-2 font-semibold text-white transition-colors hover:bg-greenbook-light-green hover:text-green-900"
            onClick={() => setPreference('granted')}
          >
            Permitir
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsConsentBanner;
